module.exports = __webpack_public_path__ + "static/img/ditu.be1b40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ditu.png
// module id = gN1L
// module chunks = 1